import { AssertionIssue, Assertion, Media, Component, Area, JobIssue, JobIssueVendor } from "../../../core/database/db";
import { ComponentConfigurationDTO } from "../../areas/models/configuration/ComponentConfigurationDTO";
import { AreaService } from "../../areas/services/area.service";
import { AssertionIssuesService } from "../../assertionIssues/services/assertion-issues.service";
import { AssertionService } from "../../assertions/services/assertion.service";
import { ComponentService } from "../../components/services/component.service";
import { JobIssueService } from "../../jobIssues/services/job-issue-service";
import { AddAreaSubmit } from "../components/job-areas/add-area/add-area-dialog.component";
import { EditRoomNameUpdate } from "../components/job-areas/edit-rooms/edit-room-names.component";
import JobDataService from "./job-data-service";
import { JobService } from "./job.service";
import { UiToastService } from "../../../shared/components/toast/ui-toast.service";
import { LoggerService } from "../../../shared/services/logger.service";
import { AssertionChanges } from "./bq-inspection-data.service";
import { BqInspectionSingleAreaDataService, ChecklistIssueDetails, ChecklistResponse } from "./bq-inspection-single-area-data.service";
import { VendorDataHelperService } from "../../vendors/services/vendor-data-helper.service";

export class DummyBqInspectionDataService extends BqInspectionSingleAreaDataService {
  constructor(private toastService: UiToastService) {
    super(
      {} as LoggerService,
      {} as AssertionIssuesService,
      {} as AssertionService,
      {} as AreaService,
      {} as JobService,
      {} as JobDataService,
      {} as ComponentService,
      {} as JobIssueService,
      {} as VendorDataHelperService
    );
  }

  override updateAreasNaStatus(_areaIds: number[], _areMarkedAreaIdsApplicable: boolean): Promise<void> {
    this.toastService.error("An error occurred while updating NA status. Please try again.");
    return Promise.resolve();
  }

  override updateAreaNames(_updates: EditRoomNameUpdate[]): Promise<void> {
    this.toastService.error("An error occurred while updating area names. Please try again.");
    return Promise.resolve();
  }

  override addNewAreaToZone(_areaDetails: AddAreaSubmit, _zoneId: number): Promise<number | undefined> {
    this.toastService.error("An error occurred while adding a new area. Please try again.");
    return Promise.resolve(undefined);
  }

  override addNewRoomForIssueAssignment(_areaDetails: AddAreaSubmit): Promise<Area> {
    this.toastService.error("An error occurred while adding a new room. Please try again.");
    return Promise.reject(new Error("Inspection data is not loaded."));
  }

  override deleteIssueForAssertion(_issue: AssertionIssue): Promise<void> {
    this.toastService.error("An error occurred while deleting the issue. Please try again.");
    return Promise.resolve();
  }

  override saveLooksGoodAssertionDetail(_assertion: Assertion, _note: string, _media: Media[]): Promise<void> {
    this.toastService.error("An error occurred while saving the 'Looks Good' details. Please try again.");
    return Promise.resolve();
  }

  override removeLooksGoodStatus(_assertion: Assertion): Promise<void> {
    this.toastService.error("An error occurred while removing the 'Looks Good' status. Please try again.");
    return Promise.resolve();
  }

  override updateIssueForAssertion(_issueId: number, _text: string, _severity: string, _media: Media[]): Promise<void> {
    this.toastService.error("An error occurred while updating the issue. Please try again.");
    return Promise.resolve();
  }

  override createIssueForAssertion(_issue: AssertionIssue, _media: Media[]): Promise<void> {
    this.toastService.error("An error occurred while creating the issue. Please try again.");
    return Promise.resolve();
  }

  override getVendorAssignmentForIssue(_issue: JobIssue): JobIssueVendor | null {
    return null;
  }

  override startJob(): Promise<void> {
    this.toastService.error("An error occurred while starting the job. Please try again.");
    return Promise.resolve();
  }

  override updateAssertionState(_assertion: Assertion, _changes: AssertionChanges): Promise<Assertion> {
    this.toastService.error("An error occurred while updating the assertion state. Please try again.");
    return Promise.resolve(_assertion);
  }

  override addNewComponentToArea(_newComponentDetail: ComponentConfigurationDTO, _areaId: number): Promise<{ addedComponent: Component, addedAssertions: Assertion[] }> {
    this.toastService.error("An error occurred while adding a new component. Please try again.");
    return Promise.resolve({ addedComponent: {} as Component, addedAssertions: [] });
  }

  override recordChecklistResponse(_assertion: Assertion, _response: ChecklistResponse, _lotAreaIdentifier: string, _issueDetails?: ChecklistIssueDetails): Promise<void> {
    this.toastService.error("An error occurred while saving your response. Please try again.");
    return Promise.resolve();
  }

  override clearChecklistResponse(_assertion: Assertion): Promise<void> {
    this.toastService.error("An error occurred while clearing your response. Please try again.");
    return Promise.resolve();
  }

  override updateChecklistIssue(_issue: AssertionIssue, _notes: string, _media: Media[]): Promise<void> {
    this.toastService.error("An error occurred while updating the issue. Please try again.");
    return Promise.resolve();
  }

}